import { service } from "../utils/service";

// 添加员工排班上钟
export function addServiceOrder(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrder/add",
    method: "post",
    data: params
  });
}

// 员工排班下钟
export function downServiceOrder(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrder/down",
    method: "post",
    data: params
  });
}

// 查询全部员工排班
export function serviceOrderList(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrder/list",
    method: "post",
    data: params
  });
}
// 查询全部员工排班其他状态
export function serviceOrderLists(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrder/lists",
    method: "post",
    data: params
  });
}

// 修改员工排班上钟顺序
export function editServiceOrder(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrder/update",
    method: "post",
    data: params
  });
}

// 添加服务单据(结算)
export function addStoreSettlement(params) {
  return service({
    url: "/api" + "/demay/ssm/storeSettlement/add",
    method: "post",
    data: params
  });
}

// 修改服务中单据
export function ediStoreSettlement(params) {
  return service({
    url: "/api" + "/demay/ssm/storeSettlement/update",
    method: "post",
    data: params
  });
}
// 添加服务单据(结算)

export function addServiceOrders(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrders/add",
    method: "post",
    data: params
  });
}

//删除服务项目
export function delStoreSettlement(params) {
  return service({
    url: "/api" + "/demay/ssm/storeSettlement/detele",
    method: "post",
    data: params
  });
}

// 结算服务
export function cancelServiceOrders(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrders/cancel",
    method: "post",
    data: params
  });
}
// 修改
export function editServiceOrders(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrders/update",
    method: "post",
    data: params
  });
}

// 查询历史单据（按月）

export function pageServiceOrders(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrders/page",
    // url: "/api" + "/demay/ssm/serviceOrders/pageNew",
    method: "post",
    data: params
  });
}
//上钟
export function updateTime(params) {
  return service({
    url: "/api" + "/demay/ssm/storeSettlement/updateTime",
    method: "post",
    data: params
  });
}
//下钟
export function updateTimeX(params) {
  return service({
    url: "/api" + "/demay/ssm/storeSettlement/updateTimeX",
    method: "post",
    data: params
  });
}
//退房
export function checkOut(params) {
  return service({
    url: "/api" + "/demay/ssm/storeSettlement/checkOut",
    method: "post",
    data: params
  });
}
//换房
export function roomChange(params) {
  return service({
    url: "/api" + "/demay/ssm/storeSettlement/roomChange",
    method: "post",
    data: params
  });
}
//房间状态
export function roomSatet(params) {
  return service({
    url: "/api" + "/demay/ssm/storeRoom/roomSatet",
    method: "post",
    data: params
  });
  // 修改员工排班上钟顺序
}
export function stateServiceOrder(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrder/update",
    method: "post",
    data: params
  });
}

// 修改员工状态
export function editsServiceOrder(params) {
  return service({
    url: "/api" + "/demay/ssm/serviceOrder/updates",
    method: "post",
    data: params
  });
}

// 或者当前人密码短信
export function getPsw(data) {
  return service({
    url: "/api" + "/demay/ssm/staffLogin/getPsw",
    method: "post",
    data
  });
}

// /zfZjWuYeController
export function zfZjWuYeController(params) {
  return service({
    url: "/api" + "/zfZjWuYeController",
    method: "get",
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/api.js